"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISO_DATE_FORMAT = exports.dayjsEn = exports.utc = exports.timezone = exports.time = exports.relativeTime = exports.parseZone = exports.weekday = exports.isBetween = exports.isWeekend = exports.isoWeek = exports.formatWeek = exports.formatTimeRange = exports.formatSignificant = exports.formatRange = exports.formatDateRange = exports.durationBetweenTimes = exports.duration = exports.customParseFormat = exports.customFormat = exports.addInTz = exports.dayjsFactory = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
// NOTE: plugins needs to be imported as '.js'
const en_gb_js_1 = __importDefault(require("dayjs/locale/en-gb.js"));
const advancedFormat_1 = __importDefault(require("dayjs/plugin/advancedFormat"));
const calendar_js_1 = __importDefault(require("dayjs/plugin/calendar.js"));
const customParseFormat_js_1 = __importDefault(require("dayjs/plugin/customParseFormat.js"));
exports.customParseFormat = customParseFormat_js_1.default;
const dayOfYear_js_1 = __importDefault(require("dayjs/plugin/dayOfYear.js"));
const duration_js_1 = __importDefault(require("dayjs/plugin/duration.js"));
exports.duration = duration_js_1.default;
const isBetween_js_1 = __importDefault(require("dayjs/plugin/isBetween.js"));
exports.isBetween = isBetween_js_1.default;
const isoWeek_js_1 = __importDefault(require("dayjs/plugin/isoWeek.js"));
exports.isoWeek = isoWeek_js_1.default;
const localizedFormat_1 = __importDefault(require("dayjs/plugin/localizedFormat"));
const relativeTime_js_1 = __importDefault(require("dayjs/plugin/relativeTime.js"));
exports.relativeTime = relativeTime_js_1.default;
const timezone_js_1 = __importDefault(require("dayjs/plugin/timezone.js"));
exports.timezone = timezone_js_1.default;
const updateLocale_js_1 = __importDefault(require("dayjs/plugin/updateLocale.js"));
const utc_js_1 = __importDefault(require("dayjs/plugin/utc.js"));
exports.utc = utc_js_1.default;
const weekday_js_1 = __importDefault(require("dayjs/plugin/weekday.js"));
exports.weekday = weekday_js_1.default;
const weekOfYear_js_1 = __importDefault(require("dayjs/plugin/weekOfYear.js"));
const enums_1 = require("@bemlo/enums");
const i18n_1 = require("@bemlo/i18n");
const add_and_subtract_in_tz_1 = require("./plugins/add-and-subtract-in-tz");
Object.defineProperty(exports, "addInTz", { enumerable: true, get: function () { return add_and_subtract_in_tz_1.addInTz; } });
const custom_format_1 = require("./plugins/custom-format");
Object.defineProperty(exports, "customFormat", { enumerable: true, get: function () { return custom_format_1.customFormat; } });
const duration_between_times_1 = require("./plugins/duration-between-times");
Object.defineProperty(exports, "durationBetweenTimes", { enumerable: true, get: function () { return duration_between_times_1.durationBetweenTimes; } });
const format_date_range_1 = require("./plugins/format-date-range");
Object.defineProperty(exports, "formatDateRange", { enumerable: true, get: function () { return format_date_range_1.formatDateRange; } });
const format_duration_1 = require("./plugins/format-duration");
const format_range_1 = require("./plugins/format-range");
Object.defineProperty(exports, "formatRange", { enumerable: true, get: function () { return format_range_1.formatRange; } });
const format_significant_1 = require("./plugins/format-significant");
Object.defineProperty(exports, "formatSignificant", { enumerable: true, get: function () { return format_significant_1.formatSignificant; } });
const format_time_range_1 = require("./plugins/format-time-range");
Object.defineProperty(exports, "formatTimeRange", { enumerable: true, get: function () { return format_time_range_1.formatTimeRange; } });
const format_week_1 = require("./plugins/format-week");
Object.defineProperty(exports, "formatWeek", { enumerable: true, get: function () { return format_week_1.formatWeek; } });
const is_weekend_1 = require("./plugins/is-weekend");
Object.defineProperty(exports, "isWeekend", { enumerable: true, get: function () { return is_weekend_1.isWeekend; } });
const parse_zone_1 = require("./plugins/parse-zone");
Object.defineProperty(exports, "parseZone", { enumerable: true, get: function () { return parse_zone_1.parseZone; } });
const time_1 = require("./plugins/time");
Object.defineProperty(exports, "time", { enumerable: true, get: function () { return time_1.time; } });
// NOTE: locales need to be imported as '.js'
require("dayjs/locale/da.js");
require("dayjs/locale/fi.js");
require("dayjs/locale/nb.js");
require("dayjs/locale/sv.js");
dayjs_1.default.extend(advancedFormat_1.default);
dayjs_1.default.extend(custom_format_1.customFormat);
dayjs_1.default.extend(customParseFormat_js_1.default);
dayjs_1.default.extend(duration_js_1.default);
dayjs_1.default.extend(duration_between_times_1.durationBetweenTimes);
dayjs_1.default.extend(format_duration_1.formatDuration);
dayjs_1.default.extend(isoWeek_js_1.default);
dayjs_1.default.extend(localizedFormat_1.default);
dayjs_1.default.extend(relativeTime_js_1.default);
dayjs_1.default.extend(time_1.time);
dayjs_1.default.extend(timezone_js_1.default);
dayjs_1.default.extend(utc_js_1.default);
dayjs_1.default.extend(calendar_js_1.default);
dayjs_1.default.extend(updateLocale_js_1.default);
dayjs_1.default.extend(format_range_1.formatRange);
dayjs_1.default.extend(format_time_range_1.formatTimeRange);
dayjs_1.default.extend(format_date_range_1.formatDateRange);
dayjs_1.default.extend(format_significant_1.formatSignificant);
dayjs_1.default.extend(format_week_1.formatWeek);
dayjs_1.default.extend(is_weekend_1.isWeekend);
dayjs_1.default.extend(isBetween_js_1.default);
dayjs_1.default.extend(dayOfYear_js_1.default);
dayjs_1.default.extend(weekOfYear_js_1.default);
dayjs_1.default.extend(weekday_js_1.default);
dayjs_1.default.extend(add_and_subtract_in_tz_1.addInTz);
dayjs_1.default.extend(parse_zone_1.parseZone);
// We want to use en-gb configuration for en. Type coming from enGb is incorrect
dayjs_1.default.updateLocale('en', en_gb_js_1.default);
Object.values(enums_1.Locale).forEach((locale) => {
    const translations = (0, i18n_1.getTranslation)('dayjs', locale);
    dayjs_1.default.updateLocale(locale, translations);
});
const dayjsFactory = (locale) => {
    const date = function (...args) {
        return (0, dayjs_1.default)(...args).locale(locale);
    };
    date.unix = (t) => {
        return dayjs_1.default.unix(t).locale(locale);
    };
    date.time = (time) => {
        return dayjs_1.default.time(time).locale(locale);
    };
    date.duration = (...args) => {
        return dayjs_1.default
            .duration(...args)
            .locale(locale);
    };
    date.durationBetweenTimes = (...args) => {
        return dayjs_1.default.durationBetweenTimes(...args).locale(locale);
    };
    date.formatDuration = (...args) => {
        return dayjs_1.default.formatDuration(...args, locale);
    };
    date.parseZone = (...args) => {
        return dayjs_1.default.parseZone(...args).locale(locale);
    };
    return date;
};
exports.dayjsFactory = dayjsFactory;
__exportStar(require("./day-to-number"), exports);
__exportStar(require("./format-time"), exports);
__exportStar(require("./from-now"), exports);
__exportStar(require("./normalize-time"), exports);
__exportStar(require("./sanitize-time-input"), exports);
__exportStar(require("./parse-date-time"), exports);
__exportStar(require("./serialize-time"), exports);
__exportStar(require("./time-validation-regex"), exports);
__exportStar(require("./types"), exports);
__exportStar(require("./unix-time"), exports);
__exportStar(require("./country-to-tz"), exports);
/**
 * DayJs with English set as locale. Useful when you don't care about locale.
 */
exports.dayjsEn = (0, exports.dayjsFactory)(enums_1.Locale.EN);
/** This is useful e.g. when comparing dates. Should not be used for displaying a date to the user. */
exports.ISO_DATE_FORMAT = 'YYYY-MM-DD';
